import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14ae8b98"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_4 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_8 = {
  key: 2,
  class: "d-flex"
}
const _hoisted_9 = { class: "d-flex gap-2" }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_13 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = ["onUpdate:modelValue"]

import { ref, onMounted, nextTick } from "vue";
import SystemService from "../../services/SystemService";
import ConfigDetail from "./ConfigDetail.vue";
import AddConfig from "./AddConfig.vue";
import { AccountRoleTypes } from "@/core/types/AccountInfos";
import { CloseBold } from "@element-plus/icons-vue";
import { ElNotification } from "element-plus";

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfigList',
  props: {
  rowId: {
    type: Number,
    required: true,
  },
  category: {
    type: String,
    required: true,
  },
  siteId: {
    type: Number,
    required: false,
  },
  role: {
    type: Number,
    required: false,
  },
  defaultData: {
    type: Array,
    required: false,
  },
},
  setup(__props) {

const props = __props;



const showedConfig = ref<any>({
  TwoFactorAuthSetting: {
    key: "TwoFactorAuthSetting",
    showedCategory: ["party"],
    showedRole: ["all"],
    type: "switch",
    getDefault: false,
  },
  LeverageAvailable: {
    key: "LeverageAvailable",
    showedCategory: ["account", "party"],
    showedRole: ["all"],
    type: "input",
    getDefault: true,
  },
  AutoCreateTradeAccountEnabled: {
    key: "AutoCreateTradeAccountEnabled",
    showedCategory: ["account"],
    showedRole: [AccountRoleTypes.IB, AccountRoleTypes.Sales],
    type: "switch",
    getDefault: false,
  },
  RebateSetting: {
    key: "DefaultRebateLevelSetting",
    showedCategory: ["account"],
    showedRole: [AccountRoleTypes.IB, AccountRoleTypes.Sales],
    type: "text",
    getDefault: false,
  },
});

const modalRef = ref<InstanceType<typeof ConfigDetail>>();
const addConfigRef = ref<any>(null);
const isLoading = ref(false);
const isSubmitting = ref(false);
const data = ref(<any>[]);
const tempData = ref<any>([]);

const fetchData = async () => {
  isLoading.value = true;

  try {
    const res = await SystemService.queryConfig(props.rowId, props.category);
    data.value = res.sort((a, b) => a.name.localeCompare(b.name));

    data.value.forEach((item) => {
      item.valueString = JSON.stringify(item.value);
    });
    if (props.category === "public" && props.rowId != 0) {
      processPublicDefaultData();
    } else if (props.category === "account" || props.category === "party") {
      await filterAvailableOptions();
    }
  } catch (e) {
    console.log(e);
  } finally {
    isLoading.value = false;
  }
};

const show = (item: any) => {
  modalRef.value?.show(props.category, props.rowId, item.key, item);
};

const filterAvailableOptions = async () => {
  var configs = <any>[];
  Object.keys(showedConfig.value).forEach((key) => {
    const item = showedConfig.value[key];
    if (
      item.showedCategory.includes(props.category) &&
      (item.showedRole.includes("all") || item.showedRole.includes(props.role))
    ) {
      configs.push(item);
    }
  });
  tempData.value = [];
  configs.forEach(async (item) => {
    await SystemService.queryConfigByKey(
      props.category,
      props.rowId,
      item.key,
      { isInherit: true }
    ).then((res) => {
      if (res) {
        res.valueString = JSON.stringify(res.value);
        res.rowId = props.rowId;
        res.type = item.type;
        if (!item.getDefault && res.category == "Public") {
          if (item.key == "AutoCreateTradeAccountEnabled") {
            res.value["value"] = true;
            res.category = "Account";
          }
        }
        tempData.value.push(res);
      }
    });
    tempData.value.sort((a, b) => a.key.localeCompare(b.key));
  });

  data.value = tempData.value;
};

const processPublicDefaultData = () => {
  const publicDefaultData = props.defaultData;
  publicDefaultData.forEach((item) => {
    const index = data.value.findIndex((i) => i.key === item.key);
    if (index === -1) {
      item.default = true;
      item.valueString = JSON.stringify(item.value);
      item.rowId = props.rowId;
      data.value.push(item);
    }
  });
};

const addInput = (item: any) => {
  const index = data.value.findIndex((i) => i.key === item.key);
  const length = Object.keys(data.value[index].value).length;
  if (index !== -1) {
    data.value[index].value[length] = 0;
  }
};

const removeInput = (item: any, key: number) => {
  const index = data.value.findIndex((i) => i.key === item.key);
  if (index !== -1) {
    data.value[index].value.splice(key, 1);
  }
};

const onChange = async (item: any) => {
  isSubmitting.value = true;
  if (item.type === "input") {
    item.value = item.value.sort((a: any, b: any) => a - b);
  }
  try {
    const submitData = {
      value: item.value,
      key: item.key,
      name: item.name,
      description: item.description,
      dataFormat: item.dataFormat,
    };
    await SystemService.updateConfigByKey(
      props.category,
      props.rowId,
      item.key,
      submitData
    ).then(() => {
      ElNotification({
        title: "Update Success",
        message: item.key,
        type: "success",
      });
    });
    await fetchData();
  } catch (e) {
    console.log(e);
    ElNotification({
      title: "Update Failed",
      message: item.key,
      type: "error",
    });
  }

  isSubmitting.value = false;
};

const handleInputChange = (item: any, key: string, val: string) => {
  const numVal = parseFloat(val);
  item.value[key] = isNaN(numVal) ? 0 : numVal;
};

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$props.category != 'public')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("table", _hoisted_3, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_4, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.name")), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.category")), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.updatedOn")), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.updatedBy")), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("action.action")), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(item.name), 1),
                    _createElementVNode("td", null, _toDisplayString(item.category), 1),
                    _createElementVNode("td", null, [
                      (item.updatedOn)
                        ? (_openBlock(), _createBlock(_component_TimeShow, {
                            key: 0,
                            type: "inFields",
                            "date-iso-string": item.updatedOn
                          }, null, 8, ["date-iso-string"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.updatedBy), 1),
                    _createElementVNode("td", _hoisted_5, [
                      (item.type == 'switch')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            (item.key != 'TwoFactorAuthSetting')
                              ? (_openBlock(), _createBlock(_component_el_switch, {
                                  key: 0,
                                  style: {"--el-switch-on-color":"#13ce66","--el-switch-off-color":"#ff4949"},
                                  modelValue: item.value['value'],
                                  "onUpdate:modelValue": ($event: any) => ((item.value['value']) = $event),
                                  "inline-prompt": "",
                                  "active-text": "ON",
                                  "inactive-text": "OFF",
                                  "active-value": true,
                                  "inactive-value": false,
                                  size: "large",
                                  onChange: ($event: any) => (onChange(item)),
                                  disabled: isSubmitting.value
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"]))
                              : (_openBlock(), _createBlock(_component_el_switch, {
                                  key: 1,
                                  style: {"--el-switch-on-color":"#13ce66","--el-switch-off-color":"#ff4949"},
                                  modelValue: item.value['loginCodeEnabled'],
                                  "onUpdate:modelValue": ($event: any) => ((item.value['loginCodeEnabled']) = $event),
                                  "inline-prompt": "",
                                  "active-text": "ON",
                                  "inactive-text": "OFF",
                                  "active-value": true,
                                  "inactive-value": false,
                                  size: "large",
                                  onChange: ($event: any) => (onChange(item)),
                                  disabled: isSubmitting.value
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"]))
                          ]))
                        : (item.type == 'text')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createVNode(_component_el_input, {
                                modelValue: item.valueString,
                                "onUpdate:modelValue": ($event: any) => ((item.valueString) = $event),
                                class: "w-100",
                                disabled: true
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              _createVNode(_component_el_button, {
                                type: "primary",
                                class: "ms-2",
                                onClick: ($event: any) => (show(item)),
                                disabled: isSubmitting.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("action.edit")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "disabled"])
                            ]))
                          : (item.type == 'input')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value, (value, key) => {
                                    return (_openBlock(), _createBlock(_component_el_input, {
                                      key: key,
                                      modelValue: item.value[key],
                                      "onUpdate:modelValue": ($event: any) => ((item.value[key]) = $event),
                                      class: "w-100px input-with-select",
                                      disabled: isSubmitting.value,
                                      onInput: (val) => handleInputChange(item, key, val)
                                    }, {
                                      prepend: _withCtx(() => [
                                        _createVNode(_component_el_icon, {
                                          color: "#ff4949",
                                          class: "cursor-pointer",
                                          onClick: ($event: any) => (removeInput(item, key)),
                                          disabled: isSubmitting.value
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(CloseBold))
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick", "disabled"])
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "onInput"]))
                                  }), 128))
                                ]),
                                _createVNode(_component_el_button, {
                                  type: "success",
                                  class: "ms-2",
                                  onClick: ($event: any) => (addInput(item)),
                                  disabled: isSubmitting.value
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("action.add")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "disabled"]),
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  class: "ms-2",
                                  onClick: ($event: any) => (onChange(item)),
                                  disabled: isSubmitting.value
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("action.save")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "disabled"])
                              ]))
                            : _createCommentVNode("", true),
                      (_ctx.$cans(['SuperAdmin']))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createVNode(_component_el_button, {
                              type: "warning",
                              onClick: ($event: any) => (show(item)),
                              disabled: isSubmitting.value,
                              class: "ms-2"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("action.edit")) + " (Super Admin)", 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick", "disabled"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ])), [
              [_directive_loading, isLoading.value]
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("table", _hoisted_12, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_13, [
                _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.name")), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.updatedOn")), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.updatedBy")), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.value")), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.$t("action.action")), 1)
              ])
            ]),
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                  _createVNode(_component_LoadingRing)
                ]))
              : (!isLoading.value && data.value.length === 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
                    _createVNode(_component_NoDataBox)
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: index,
                        class: _normalizeClass({ 'bg-success': !item.default && __props.rowId != 0 })
                      }, [
                        _createElementVNode("td", null, _toDisplayString(item.name), 1),
                        _createElementVNode("td", null, [
                          (item.updatedOn)
                            ? (_openBlock(), _createBlock(_component_TimeShow, {
                                key: 0,
                                type: "inFields",
                                "date-iso-string": item.updatedOn
                              }, null, 8, ["date-iso-string"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(item.updatedBy), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_17, [
                            _withDirectives(_createElementVNode("input", {
                              disabled: "",
                              type: "text",
                              class: "form-control",
                              "onUpdate:modelValue": ($event: any) => ((item.valueString) = $event)
                            }, null, 8, _hoisted_18), [
                              [_vModelText, item.valueString]
                            ])
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: ($event: any) => (show(item))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("action.edit")), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_el_button, {
                            type: "danger",
                            onClick: ($event: any) => (_ctx.openConfirmPanel(item))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("action.delete")), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ], 2))
                    }), 128))
                  ]))
          ])
        ])),
    _createVNode(ConfigDetail, {
      ref_key: "modalRef",
      ref: modalRef,
      onSubmitted: fetchData
    }, null, 512),
    _createVNode(AddConfig, {
      ref_key: "addConfigRef",
      ref: addConfigRef,
      onSubmitted: fetchData
    }, null, 512)
  ], 64))
}
}

})